<template>
  <div class="advertising">
    <div class="advertising__slider" v-if="promoSliderLocal">
      <template v-if="promoSliderLocal.items">
      <swiper ref="swiper"
              class="swiper-container"
              :modules="modules"
              :autoplay="{delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: true}"
              loop
              :navigation="{prevEl: '.advertising__slider .advertising__slider-prev', nextEl: '.advertising__slider .advertising__slider-next'}"
              @slideChange="onSlideChange"
      >
        <swiper-slide v-for="(image, index) in promoSliderLocal.items" :key="index">
          <a :href="image.targetUrl" :data-slide-index="index">
            <img :src="image.imageUrl">
          </a>
        </swiper-slide>
      </swiper>
      <div v-if="promoSliderLocal.items.length > 1" class="advertising__slider-controls">
        <button class="advertising__slider-prev" tabindex="-1">
          <svg-icon icon="arrow-left" width="24" height="24" viewBox="0 0 16 16" />
        </button>
        <div class="advertising__slider-position">
          <div>
            <span>{{ activeIndex + 1 }}</span> / <span>{{ promoSliderLocal.items.length }}</span>
          </div>
        </div>
        <button class="advertising__slider-next" tabindex="-1">
          <svg-icon icon="arrow-right" width="24" height="24" viewBox="0 0 16 16" />
        </button>
      </div>
      </template>
    </div>
    <div v-else class="advertising__slider data-waiting-animation"></div>
  </div>
</template>

<script>
import {post} from "@/common/fetch";
import {retryAsyncFunction, delay} from '@/common/util/promises';
import AdvertisingOffers from '../advertisingOffers/AdvertisingOffersComponentDesktop.vue';
import SvgIcon from "@/common/controls/SvgIconControl.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import {Autoplay, Navigation} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export default {
  components: {
    AdvertisingOffers,
    Swiper,
    SwiperSlide,
    SvgIcon,
  },
  props: {
    slider: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeIndex: 0,
      promoSliderLocal: this.slider,
    };
  },
  created() {
    if (!this.isPromoSliderLoaded(this.promoSliderLocal)) {
      delay(1000).then(() => this.fetchCmsPromoSliderData());
    }
  },
  mounted() {
    // this.$refs.swiper.swiperRef.autoplay.start();
  },
  computed: {
    modules() {
      if (this.promoSliderLocal.items.length > 1) {
        return [Autoplay, Navigation]        
      }
      return [];
    },
  },
  methods: {
    isPromoSliderLoaded(data) {
      return data && data.items !== null;
    },
    isPromoLinksSliderLoaded(data) {
      return data && data.items !== null;
    },
    fetchCmsPromoSliderData() {
      retryAsyncFunction(
          10,
          1000,
          (res) => this.isPromoSliderLoaded(res),
          () => post("/Home/GetBottomSlider", {})
      ).then(res => {
        this.promoSliderLocal = {
          ...this.promoSliderLocal,
          ...res,
        };
      }).catch(() => console.error("Fetch CMS promo slider failed"));
    },
    
    onSlideChange(swiper) {
      // Слайдер дублирует слайды, чтобы незаметно делать транзишен между последним и первым слайдом. 
      // В аргументе есть activeIndex и realIndex которые должны отражать этот момент. 
      // Но по факту для 3-х слайдов оба показываю значения [1, 2, 3, 4] одновременно.
      this.$nextTick(() => {
        const activeSlide = this.$refs.swiper.$el.querySelector(".swiper-slide.swiper-slide-active > :first-child");
        if (activeSlide) {
          this.activeIndex = parseInt(activeSlide.dataset.slideIndex);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.advertising {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.advertising__slider {
  position: relative;

  &.data-waiting-animation {
    height: 352px;
  }

  :deep(img) {
    width: 840px;
    height: 100%;
    object-fit: cover;
  }
}

.swiper-container {
  border-radius: var(--border-radius-lg);
  width: 840px;
  height: 352px;
}

.advertising__slider-controls {
  position: absolute;
  inset: 20px 10px;
  z-index: 1;
  pointer-events: none;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
}

.advertising__slider-prev,
.advertising__slider-next {
  display: flex;
  opacity: 0;
  transition: opacity .3s ease;
  flex: 0 0 auto;
  width: 60px;
  height: 60px;
  padding: 10px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: var(--white);
  outline: none;
  pointer-events: all;
  border: none;
  color: var(--second-10);
  box-shadow: var(--shadow);
  
  &:hover {
    box-shadow: var(--shadow-hover);
  }

  [dir="rtl"] & {
    svg {
      transform: rotate(180deg);
    }
  }
}

.advertising__slider-position {
  position: absolute;
  left: 10px;
  bottom: 0;
  
  > * {
    display: inline-block;
    font-size: 11px;
    line-height: 16px;
    color: var(--second-10);
    opacity: .6;
    padding: 2px 4px;
    border-radius: var(--border-radius-sm);
    background-color: var(--white);
  }
}

.advertising__offers {
  &.advertising__offers_waiting {
    display: flex;
    flex-flow: row nowrap;
    gap: 20px;

    > * {
      height: 90px;
      flex: 1 1 0;
    }
  }
}

.advertising__slider:hover {
  .advertising__slider-prev,
  .advertising__slider-next {
    display: flex;
    opacity: 0.6;

    &:active {
      opacity: 1;
    }
  }
}
</style>




